export default "__VITE_ASSET__BsajbS8S__"